import { PUBLISH_STATUS, TARGETING_STATE } from 'personalization-lib/constants/assetData';
import { isPublishedStatus, isScheduledStatus, isSuggestedStatus } from 'personalization-lib/utils/status';
const isUrlFilter = filter => filter.type === 'URL' || filter.type === 'QUERY_PARAM';
const extractBaseFilters = filter => {
  if (filter.type === 'BOOLEAN') {
    return filter.values.flatMap(extractBaseFilters);
  }
  return [filter];
};
const hasVisitorFilters = audienceFilters => {
  if (!audienceFilters) {
    return false;
  }
  return extractBaseFilters(audienceFilters).some(filter => !isUrlFilter(filter));
};
export const getTargetingState = content => {
  if (content.audienceFilters && hasVisitorFilters(content.audienceFilters)) {
    return TARGETING_STATE.AUDIENCE_FILTERS;
  }
};
export const getSimplifiedPublishStatus = state => {
  if (isSuggestedStatus(state)) {
    return PUBLISH_STATUS.AI_SUGGESTED;
  }
  if (isScheduledStatus(state)) {
    return PUBLISH_STATUS.SCHEDULED;
  }
  if (isPublishedStatus(state)) {
    return PUBLISH_STATUS.PUBLISHED;
  }
  return PUBLISH_STATUS.DRAFT;
};
export const mapContentData = content => ({
  id: content.id,
  status: content.personalizationVariantStatus,
  name: content.label,
  imgSrc: content.screenshotPreviewUrl,
  updatedById: content.updatedById,
  publishStatus: getSimplifiedPublishStatus(content.currentState),
  previewKey: content.previewKey,
  targetingState: 'audienceFilters' in content ? getTargetingState(content) : undefined
});